import { useEffect, useState } from "react";
import * as ReactDOMServer from 'react-dom/server';

import app from "../components/app" 
import encrypt from "../components/encrypt" 
import HeaderHTML from "../preview/header" 
import headerJson from "../components/header.json" 
import FooterHTML from "../preview/footer" 
import footerJson from "../components/footer.json" 
import DivKit2 from "./divKit2" 

let deviceView = "desktop";
if(window.location.pathname === "/appmakr/creator-software/build") {
    deviceView = "mobile";
}
if(window.location.pathname === "/website/creator-software/build") {
    if(app.isMobile() === "is-mobile") {
        deviceView = "mobile";
    }
    else {
        deviceView = "desktop";
    }
}

const getFeaturePages = function() {
    return new Promise(function(resolve){
        if(localStorage.getItem("featurePages")) {
            resolve(JSON.parse(localStorage.getItem("featurePages")));
        }
        else {
            app.fetchPost({"method":"getAllFeaturePages","appId":localStorage.getItem("aiAppId")}).then(function(response){
                localStorage.setItem("featurePages", JSON.stringify(response.data));
                resolve(response.data);
            })
        }
    });
}

function fitToParentWidth(child, parent) {
    const parentWidth = parent.offsetWidth;
    const parentHeight = parent.offsetHeight;
    const childWidth = child.scrollWidth;
  
    // scale factor (based on width)
    const scale = parentWidth / childWidth;
  
    // adjust height BEFORE scaling so that after scaling it matches parent
    const desiredHeight = parentHeight / scale;
    child.style.height = desiredHeight + "px";
  
    // apply transform scale
    child.style.transform = `scale(${scale})`;
    child.style.transformOrigin = "top left";
  }
  
  // usage


const getDivkitJson = async function(){
    // localStorage.setItem("aiAppId", "50f2925665dd");
    // localStorage.setItem("aiPageId", "about_1732639002100_1");
    // localStorage.setItem("userEmail", "ravi@appypie.com");
    // localStorage.setItem("userId", "470814");

    const response = await app.fetchPost({
        method: "getPage",
        appId: localStorage.getItem("aiAppId"),
        pageId: localStorage.getItem("aiPageId")
    }, true);

    return JSON.parse(response.pageDataJson);
}

const setDivkitJson = async function(data){
    const response = await app.fetchPost({
        method: "savePageData",
        appId: localStorage.getItem("aiAppId"),
        pageId: localStorage.getItem("aiPageId"),
        id: data.id,
        pageDataJson:JSON.stringify(data),
        userId: "123456",
        publish: 0
    }, true);
    return response;
}





export const action = function(type, value){
    if(window.childPost) {
        window.childPost({ type, value });
    }
    //document.querySelector("#divkit-area iframe").contentWindow.postMessage({ type, value }, '*');
}

const headerCallback = function(text){
    if(text === "mobile") {
        action("switchview", text);
         if(document.querySelectorAll(".device-view-switch a")) {
            document.querySelectorAll(".device-view-switch a").forEach(function(v){
                v.classList.remove("active")
            });
            if(document.querySelectorAll(".device-view-switch a")[0]) {
                document.querySelectorAll(".device-view-switch a")[0].classList.add("active");
            }
        }
    }
    if(text === "desktop") {
        action("switchview", text);
        if(document.querySelectorAll(".device-view-switch a")) {
            document.querySelectorAll(".device-view-switch a").forEach(function(v){
                v.classList.remove("active")
            });
            if(document.querySelectorAll(".device-view-switch a")[1]) {
                document.querySelectorAll(".device-view-switch a")[1].classList.add("active");
            }
        }
    }
    if(text === "undo") {
        action("undoredo", text);
    }
    if(text === "redo") {
        action("undoredo", text);
    }
}

const divkitPublishEvent = function(container, callback) {
     action("publishEvent", "done");
}

export default function(props) {
    useEffect(() => {
        window.getDivkitJson = getDivkitJson;
        window.setDivkitJson = setDivkitJson;
        window.divkitPublishEvent = divkitPublishEvent;
        window.headerFooterHTML = loadHtml;
        window.saveAILogo = app.saveAILogo;
        
        if(localStorage.getItem("isTemplate")) {
            loadHtml(function(){

            });
        }
        else {
            app.fetchPost({
                method: "getPage",
                appId: localStorage.getItem("aiAppId"),
                pageId: localStorage.getItem("aiPageId")
            }, true).then(function(pResponse){
                if(pResponse.isTemplateFlow === true) {
                    localStorage.setItem("isTemplate", true);
                }
                else {
                    localStorage.setItem("isTemplate", false);
                }
                loadHtml(function(){

                });
            })
        }
        
        

        window.parentPost = messageHandler;
        if(!window.messageHandlerMode) {
            //window.addEventListener("message", messageHandler);
            window.messageHandlerMode = true;
        }
        
        window.headerCallback = headerCallback;
        if(localStorage.device === "mobile") {
            headerCallback("mobile");
        }
        else {
            headerCallback("desktop");
        }

        window.trialToast = function(event, txt){
            const message = txt || `${app.getLang("you_are_on_preview_mode")} <span class="trial-toast-link" role="button" tabindex="0">${app.getLang("trial")}</span>.`;
            const existing = document.querySelector(".trial-toast");
            if(existing) {
                existing.remove();
            }
            const div = document.createElement("div");
            const hasPos = event && typeof event.clientX === "number" && typeof event.clientY === "number";
            div.setAttribute("class", "trial-toast" + (hasPos ? " trial-toast--bubble" : ""));
            div.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                <span>${message}</span>
            `;
            if(hasPos) {
                div.style.left = (event.clientX + 12) + "px";
                div.style.top = (event.clientY - 12) + "px";
            }
            const link = div.querySelector(".trial-toast-link");
            if(link) {
                const handler = function(ev){
                    ev.preventDefault();
                    ev.stopPropagation();
                    const btn = document.querySelector(".aps-edit-manual-btn");
                    if(btn) {
                        btn.click();
                    }
                    div.remove();
                };
                link.addEventListener("mousedown", handler);
                link.addEventListener("click", handler);
            }
            document.body.appendChild(div);
            setTimeout(function(){
                if(div.parentNode) div.remove();
            }, 3000);
        };
    }, []);

    const disabledAreaClick = function(e){
        if(window.trialToast) {
            window.trialToast(e);
        }
    }

    const messageHandler = function(data){
        const {type, value} = data;
        console.log('Message from parent:', data);
        if(type === "showHeader") {
            window.setDivkitMode2("header");
        }
        if(type === "getHomePageFeature") {
            if(window.getHomePageFeature) {
                window.getHomePageFeature();
            }
            else {
                console.log("getHomePageFeature not found");
            }
        }
        if(type === "sidebarCollapse") {
            console.log("sidebarCollapse called");
            if(document.querySelector("#collapse-sidebar-mobile")) {
                console.log("sidebarCollapse buttin found");
                document.querySelector("#collapse-sidebar-mobile").click();
            }
            else {
                console.log("sidebarCollapse not found");
            }
        }
        if(type === "saveAILogo") {
            window.saveAILogo(value.businessName, value.feature);
        }
        if(type === "showFooter") {
            //window.showFooter()
            //localStorage.setItem("divkitMode", "footer");
            //props.setDivkitMode("footer");
            window.setDivkitMode2("footer");
        }
        if(type === "hideArea") {
            if(document.querySelector(".site-header-new")) {
                document.querySelector(".site-header-new").classList.add("disabled-area");
                document.querySelector(".site-header-new").addEventListener("click", disabledAreaClick);
            }
            if(document.querySelector("#beSidebar")) {
                document.querySelector("#beSidebar").classList.add("disabled-area");
                document.querySelector("#beSidebar").addEventListener("click", disabledAreaClick);
            }
        }
        if(type === "showArea") {
            if(document.querySelector(".site-header-new")) {
                document.querySelector(".site-header-new").classList.remove("disabled-area");
                document.querySelector(".site-header-new").removeEventListener("click", disabledAreaClick);
            }
            if(document.querySelector("#beSidebar")) {
                document.querySelector("#beSidebar").classList.remove("disabled-area");
                document.querySelector("#beSidebar").removeEventListener("click", disabledAreaClick);
            }
        }
        if(type === "parentLoaded") {
            loadHtml();
            if(window.closeLoaderOfIFrame) {
                console.log("yes found closeLoaderOfIFrame");
                window.closeLoaderOfIFrame();
            }
            else {
                console.log("not found closeLoaderOfIFrame")
            }
        }
        if(type === "saveAppkit") {
             if(localStorage.getItem("showSaveModal") === "1") {
                document.querySelector(".btn.btn-success.publish-btn.startTrialModal").click();
            }
            else {
                document.querySelector(".btn.btn-success.publish-btn").click();
            }
        }
        if(type === "setDevice") {
            window.setPreviewDevice(value);
        }
        if(type === "appkitPreview") {
            if(value) {
                document.querySelector("body").classList.add("expand-view");
                props.setAppkitPreview(value);
            }
            else {
                document.querySelector("body").classList.remove("expand-view");
                props.setAppkitPreview(value);
            }
        }
    }

    const getHeaderFooter = function(mode) {
        return new Promise(function(resolve){
            if(mode) {
                props.getHeaderFooter().then(function(response){
                    localStorage.setItem("getHeaderFooter", JSON.stringify(response));
                    resolve(response);
                }) 
            }
            else {
                if(localStorage.getItem("getHeaderFooter")) {
                    resolve(JSON.parse(localStorage.getItem("getHeaderFooter")));
                }
                else {
                    props.getHeaderFooter().then(function(response){
                        localStorage.setItem("getHeaderFooter", JSON.stringify(response));
                        resolve(response);
                    })
                }
            }
        });
    }

    const loadHtml = function(callback) {
        getFeaturePages().then(function(pages){
            getHeaderFooter(callback).then(function(response){
                console.log("loadHtml : getFeaturePages : getHeaderFooter", response, pages)
                const headerData = response.headerData?response.headerData:headerJson.headerAIData[0];
                const footerData = response.footerData?response.footerData:footerJson.footerAIData[0];
                const headerDesktop = ReactDOMServer.renderToStaticMarkup(<HeaderHTML newPages={pages} data={headerData} mode="live" device="desktop" />);
                const footerDesktop = ReactDOMServer.renderToStaticMarkup(<FooterHTML data={footerData} mode="live" device="desktop" />);
                const headerMobile = ReactDOMServer.renderToStaticMarkup(<HeaderHTML newPages={pages} data={headerData} mode="live" device="mobile" />);
                const footerMobile = ReactDOMServer.renderToStaticMarkup(<FooterHTML data={footerData} mode="live" device="mobile" />)
                action("appHtml", {
                    fontsLink:app.setFontsLive2([headerData, footerData]),
                    headerDesktop,
                    footerDesktop,
                    headerMobile,
                    footerMobile
                });
                if(callback) {
                    callback();
                }
            });
        });
    }

    const pageInfo = encrypt.encrypt2(JSON.stringify({
        appId:localStorage.getItem("aiAppId"),
        pageId:localStorage.getItem("aiPageId"),
        userEmail:localStorage.getItem("userEmail"),
        userId:localStorage.getItem("userId")
    }));
    return <DivKit2 />
    // let divkitURL = window.location.host.indexOf("localhost") !== -1?"http://localhost:5173/":app.config().divkitURL
    // return <div id="divkit-area" className="w-100 h-100 overflow-hidden">
    //     <iframe id="iframe" src={`${divkitURL}?appInfo=${encodeURIComponent(pageInfo)}&mode=${deviceView}`} style={{width:"100%", height:"100%"}} frameBorder="0" />
    // </div>
}